module.exports = __webpack_public_path__ + "static/img/background-img.c6bc3233.png";